import React, { useContext, useState } from 'react';
import { useParams } from 'react-router-dom';
import { PartnerContext } from '../../context/PartnerContext';
import { ApiContext } from '../../App';


const AddPositionForm = () => {
  const API = useContext(ApiContext);
  const { positionFormData, setPositionFormData, setShowPositionForm } = useContext(PartnerContext);
  const { id } = useParams(); // Récupère l'ID du partenaire depuis l'URL
  const [partner, setPartner] = useState(null);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  // Gérer la soumission du formulaire de poste
  const handlePositionFormSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccessMessage('');

    try {
      const response = await API.post(
        `/api/positions/partners/${id}/positions`,
        {
          ...positionFormData,
          skills: positionFormData.skills.split(',').map((skill) => skill.trim()), // Convertit en tableau
          languages : positionFormData.languages.split(',').map((language) => language.trim())
        }
      );

      // Ajouter le poste créé à la liste des postes ouverts
      setPartner({
        ...partner,
        openPositions: [...(partner?.openPositions || []), response.data]
      });

      // Réinitialiser le formulaire
      setPositionFormData({
        title: '',
        description: '',
        experience: 0,
        skills: '',
        languages: '',
        education: '',
        location: '',
        salary: '',
        contractType: '',
        applicationLink: ''
      });

      setShowPositionForm(false); // Fermer le formulaire après soumission
      setSuccessMessage('Position successfully added!');
    } catch (error) {
      console.error('Error adding position:', error);
      setError(error.response?.data?.message || 'Failed to add position. Please try again.');
    }
  };

  return (
    <div>
      {error && <div className="text-red-500 mb-4">{error}</div>}
      {successMessage && <div className="text-green-500 mb-4">{successMessage}</div>}

      {/* Formulaire pour ajouter un poste */}
      <form
        onSubmit={handlePositionFormSubmit}
        className="space-y-4 mb-6 p-4  rounded-lg  "
      >
        <div className="mb-4">
          <label className="block text-sm font-bold">Title</label>
          <input
            type="text"
            value={positionFormData.title}
            onChange={(e) => setPositionFormData({ ...positionFormData, title: e.target.value })}
            className="w-full p-2 border rounded"
            required
          />
        </div>

        <div className="mb-4">
          <label className="block text-sm font-bold">Description</label>
          <textarea
            value={positionFormData.description}
            onChange={(e) => setPositionFormData({ ...positionFormData, description: e.target.value })}
            className="w-full p-2 border rounded"
          />
        </div>

        <div className="mb-4">
          <label className="block text-sm font-bold">Experience (years)</label>
          <input
            type="number"
            value={positionFormData.experience}
            onChange={(e) => setPositionFormData({ ...positionFormData, experience: e.target.value })}
            className="w-full p-2 border rounded"
          />
        </div>

        <div className="mb-4">
          <label className="block text-sm font-bold">Skills (comma-separated)</label>
          <input
            type="text"
            value={positionFormData.skills}
            onChange={(e) => setPositionFormData({ ...positionFormData, skills: e.target.value })}
            className="w-full p-2 border rounded"
          />
        </div>

        <div className="mb-4">
          <label className="block text-sm font-bold">Languages (comma-separated)</label>
          <input
            type="text"
            value={positionFormData.languages}
            onChange={(e) => setPositionFormData({ ...positionFormData, languages: e.target.value })}
            className="w-full p-2 border rounded"
          />
        </div>

        <div className="mb-4">
          <label className="block text-sm font-bold">Education</label>
          <input
            type="text"
            value={positionFormData.education}
            onChange={(e) => setPositionFormData({ ...positionFormData, education: e.target.value })}
            className="w-full p-2 border rounded"
          />
        </div>

        <div className="mb-4">
          <label className="block text-sm font-bold">Location</label>
          <input
            type="text"
            value={positionFormData.location}
            onChange={(e) => setPositionFormData({ ...positionFormData, location: e.target.value })}
            className="w-full p-2 border rounded"
          />
        </div>

        <div className="mb-4">
          <label className="block text-sm font-bold">Salary</label>
          <input
            type="text"
            value={positionFormData.salary}
            onChange={(e) => setPositionFormData({ ...positionFormData, salary: e.target.value })}
            className="w-full p-2 border rounded"
          />
        </div>

        <div className="mb-4">
          <label className="block text-sm font-bold">Contract Type</label>
          <select
            value={positionFormData.contractType}
            onChange={(e) => setPositionFormData({ ...positionFormData, contractType: e.target.value })}
            className="w-full p-2 border rounded"
            required
          >
            <option value="" disabled>Contract Type</option>
            <option value="CDI">CDI</option>
            <option value="CDD">CDD</option>
            <option value="Freelance">Freelance</option>
          </select>
        </div>

        <div className="mb-4">
          <label className="block text-sm font-bold">Application Link</label>
          <input
            type="url"
            value={positionFormData.applicationLink}
            onChange={(e) => setPositionFormData({ ...positionFormData, applicationLink: e.target.value })}
            className="w-full p-2 border rounded"
          />
        </div>

        <button
          type="submit"
          className="w-full bg-green-500 text-white py-2 rounded hover:bg-green-600"
        >
          Submit
        </button>
      </form>
    </div>
  );
};

export default AddPositionForm;